import { call, put, takeEvery, takeLatest } from "redux-saga/effects";

// Login Redux States
import { LOGIN_USER, LOGOUT_USER, SOCIAL_LOGIN } from "./actionTypes";
import { apiError, loginSuccess, logoutUserSuccess } from "./actions";

//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import { postSocialLogin } from "../../../helpers/fakebackend_helper";
import { postLogin } from "../../../helpers/jwt_helper";
import { getErrorMessage } from "../../../helpers/utils";
import { updateAuthorizationToken } from "../../../helpers/api_helper";
import { getUserSettings, userGetPermissions, userSetIsLogin, userSetPermissions } from "../../user/actions"

const fireBaseBackend = getFirebaseBackend()

function* loginUser({ payload: { user, history } }) {
  try {
    // console.log('++++');
    const response = yield call(postLogin, {
      email: user.email,
      password: user.password,
    })
    console.log(user)
    // console.log('Response:', response);
    localStorage.setItem("authUser", JSON.stringify(response))
    updateAuthorizationToken(response.access)
    yield put(userSetIsLogin(true))
    yield put(loginSuccess(response))
    yield put(getUserSettings())
    yield put(userGetPermissions())
    history.push("/dashboard")
  } catch (error) {
    console.log(error);
    const msg = getErrorMessage(error)
    yield put(apiError(msg))
  }
}

function* logoutUser({ payload: { history } }) {
  try {
    localStorage.removeItem("authUser")
    yield put(logoutUserSuccess())
    yield put(userSetIsLogin(false))
    yield put(userSetPermissions(undefined))
    history.push("/login")
  } catch (error) {
    yield put(apiError(error))
  }
}

function* socialLogin({ payload: { data, history, type } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend = getFirebaseBackend()
      const response = yield call(
        fireBaseBackend.socialLoginUser,
        data,
        type
      )
      localStorage.setItem("authUser", JSON.stringify(response))
      yield put(loginSuccess(response))
    } else {
      const response = yield call(postSocialLogin, data)
      localStorage.setItem("authUser", JSON.stringify(response))
      yield put(loginSuccess(response))
    }
    history.push("/dashboard")
  } catch (error) {
    yield put(apiError(error))
  }
}

function* authSaga() {
  yield takeEvery(LOGIN_USER, loginUser)
  yield takeLatest(SOCIAL_LOGIN, socialLogin)
  yield takeEvery(LOGOUT_USER, logoutUser)
}

export default authSaga
